import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';
import DownloadCountryPoliciesResponses from '../../../services/downloadCountryPoliciesResponsesTable.jsx';
import '../../../styles/pages.css'; 





function PoliciesResponsesTable(props) {
  //console.log("props");
 //console.log(props);
   
    const { t } = useTranslation();
    const [oneCountryFromServer, setOneCountryFromServer] = useState("");


    useEffect(() => {
    
      const setData = async () => {
      setOneCountryFromServer(props.dataFiltered);
      }
  
      setData();
  }, [props.lang, props.country, props.dataFiltered]);
 
  
  
    return (
    <React.Fragment>  
      <div className="App">
           <br></br> 
       
  {/* Table with data from server */}
    {Array.isArray(oneCountryFromServer) && 
        oneCountryFromServer !== undefined && 
        oneCountryFromServer !== null && oneCountryFromServer.length > 0 ? 
       <div>
       
     <div>  
      <br/>
     <div style={{display: "flex", justifyContent: "flex-end"}}>
       <span> 
        <DownloadCountryPoliciesResponses type={"policies"} country={props.country} data={oneCountryFromServer}/> 
        </span> 
        </div>
      <p className="table-grey-column-non-bold-text">{t('legend_in_place')}</p>
    
     <span className="legend-element table-grey-column-non-bold-text"><img  style={{marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} }fill="red" src={process.env.PUBLIC_URL + `/img/circle_YES.svg`} alt="arrow down icon" />{t('legend_yes')}</span>
     <span className="legend-element table-grey-column-non-bold-text"><img style={{marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } fill="red" src={process.env.PUBLIC_URL + `/img/circle_NO_BUT_INITIATED.svg`} alt="arrow down icon" />{t('legend_initiated')}</span>
     <span className="legend-element table-grey-column-non-bold-text"><img  style={{marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } fill="red" src={process.env.PUBLIC_URL + `/img/circle_NO.svg`} alt="arrow down icon" />{t('legend_no')}</span>
     <span className="legend-element table-grey-column-non-bold-text"><img  style={{marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } fill="red" src={process.env.PUBLIC_URL + `/img/circle_NO_INFO.svg`} alt="arrow down icon" />{t('legend_not_available')}</span>
  
<br/>

     <div className="wrapper">
     <Table  borderless 
      style ={{ borderSpacing: "0",borderCollapse: "collapse",
      borderStyle: "hidden", marginBottom: "0px",  
      borderBottom:"0px solid trasparent !important", 
      orderBottomWidth: "0"}} >
          <thead >
    <tr >
      <th style={{backgroundColor:"#F2F2F2" }}  scope="col"><h6 style={{textAlign: props.lang !== "ar" ? "left" : "right"}} 
      className="target-legend-element ">{t('target_table_item')} A</h6> </th>
      <th className="country-table-header" style={{backgroundColor:"#F2F2F2" }} scope="col">{t('table_heading_in_place')}</th>
      <th className="country-table-header" style={{backgroundColor:"#F2F2F2" }} scope="col">{t('table_heading_est')}</th>
      <th className="country-table-header" style={{backgroundColor:"#F2F2F2" }} scope="col">{t('table_heading_areas')}</th>
    </tr>

  </thead>
     
      <tbody>
      <tr>
      <td style={{backgroundColor:"#EDF1B9" }} colSpan={4}><p className="target-indicator-title">{`${t('target_table_item')} A.1 ${t('target_A_1')}`}</p></td>   
        </tr>  
        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.1.1 ${t('indicator_A_11')}`}</span>
          </p></td>
            <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? oneCountryFromServer.filter(ans => ans.question === 5).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 5)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } >
            <span  
            className="target-indicator-text">{oneCountryFromServer !== undefined ? 
            oneCountryFromServer.filter(ans => ans.question === 5).length > 0 && 
            oneCountryFromServer.filter(ans => ans.question === 5)[0].value === "0" && 
            oneCountryFromServer.filter(ans => ans.question === 7).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 7)[0].value : "" : ""}</span></p>
          </td>
            <td className="col-3" style={{verticalAlign:"middle"}}>
             <span className="target-indicator-text">
             {oneCountryFromServer !== undefined ? 
             oneCountryFromServer.filter(ans => ans.question === 5).length > 0 && 
             oneCountryFromServer.filter(ans => ans.question === 5)[0].value === "0" && 
            oneCountryFromServer.filter(ans => ans.question === 8).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 8).length === 1 ?
            oneCountryFromServer.filter(ans => ans.question === 8)[0].value === "0" ? 
            <p>{t('result_conservation_FGR')}</p> : 
             oneCountryFromServer.filter(ans => ans.question === 8)[0].value === "1" ? 
             <p>{t('result_production_fores')}</p> :
             oneCountryFromServer.filter(ans => ans.question === 8)[0].value === "2" ?
             <p>{t('result_research_dev')}</p>  : 
           oneCountryFromServer.filter(ans => ans.question === 8)[0].value  === "3" ? 
           <p>{t('result_FGR_transferred')}</p> :
        oneCountryFromServer.filter(ans => ans.question === 8)[0].value === "4" ? <p>{t('result_other')}</p> : "" : 
        
        oneCountryFromServer.filter(ans => ans.question === 8).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
        <p key={res.value + "8"}>{t('result_conservation_FGR')}</p> : 
       res.value === "1" ? 
         <p key={res.value + "8"}>{t('result_production_fores')}</p> :
        res.value === "2" ?
       <p key={res.value + "8"}>{t('result_research_dev')}</p> : 
       res.value  === "3" ? 
       <p key={res.value + "8"}>{t('result_FGR_transferred')}</p> : <p key={res.value + "8"}>{t('result_other')}</p> ) : "" : ""}</span> 
            </td>
        </tr>  

        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.1.2 ${t('indicator_A_12')}`}</span>
          </p></td>
            <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? oneCountryFromServer.filter(ans => ans.question === 19).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 19)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } >
            <span className="target-indicator-text">{
            oneCountryFromServer !== undefined 
            ? 
            oneCountryFromServer.filter(ans => ans.question === 19).length > 0 && 
             oneCountryFromServer.filter(ans => ans.question === 19)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 21).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 21)[0].value : "" : ""}</span>
          </p></td>

          <td className="col-3" style={{verticalAlign:"middle"}}>
             <span className="target-indicator-text ">
             {oneCountryFromServer !== undefined ? 
             oneCountryFromServer.filter(ans => ans.question === 19).length > 0 && 
             oneCountryFromServer.filter(ans => ans.question === 19)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 22).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 22).length === 1 ?
            oneCountryFromServer.filter(ans => ans.question === 22)[0].value === "0" ? 
            <p>{t('result_conservation_FGR')}</p> : 
             oneCountryFromServer.filter(ans => ans.question === 22)[0].value === "1" ? 
             <p>{t('result_production_fores')}</p> :
             oneCountryFromServer.filter(ans => ans.question === 22)[0].value === "2" ?
           <p>{t('result_research_dev')}</p> : 
           oneCountryFromServer.filter(ans => ans.question === 22)[0].value  === "3" ? 
           <p>{t('result_FGR_transferred')}</p> :
        oneCountryFromServer.filter(ans => ans.question === 22)[0].value === "4" ? <p >{t('result_other')}</p> : "" : 
        
        oneCountryFromServer.filter(ans => ans.question === 22).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
        <p key={res.value + "22"}>{t('result_conservation_FGR')}</p> : 
       res.value === "1" ? 
         <p key={res.value + "22"}>{t('result_production_fores')}</p> :
        res.value === "2" ?
       <p key={res.value + "22"}>{t('result_research_dev')}</p> : 
       res.value  === "3" ? 
       <p key={res.value + "22"}>{t('result_FGR_transferred')}</p> : <p key={res.value + "22"}>{t('result_other')}</p> ) : "" : ""}</span> 
            </td>
        </tr>  



    <tr>
      <td style={{backgroundColor:"#FBD9CF" }} colSpan={4}><p className="target-indicator-title">{`${t('target_table_item')} A.2 ${t('target_A_2')}`}</p></td>
        </tr>  
        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.2.1 ${t('indicator_A_21')}`}</span>
          </p></td>
        <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? oneCountryFromServer.filter(ans => ans.question === 34).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 34)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } >
            <span className="target-indicator-text">{oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 34).length > 0 && 
              oneCountryFromServer.filter(ans => ans.question === 34)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 36).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 36)[0].value : "" : ""}</span>
          </p></td>

          <td className="col-3" style={{verticalAlign:"middle"}}>
             <span className="target-indicator-text ">
             {oneCountryFromServer !== undefined ? 
            oneCountryFromServer.filter(ans => ans.question === 37).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 34).length > 0 && 
            oneCountryFromServer.filter(ans => ans.question === 34)[0].value === "0" ?
            oneCountryFromServer.filter(ans => ans.question === 37).length === 1 ?

            oneCountryFromServer.filter(ans => ans.question === 37)[0].value === "0" ? 
            <p>{t('result_in_situ_conservation')}</p> : 
             oneCountryFromServer.filter(ans => ans.question === 37)[0].value === "1" ? 
             <p>{t('result_protected_areas')}</p> :
             oneCountryFromServer.filter(ans => ans.question === 37)[0].value === "2" ?
           <p>{t('result_forests_managed')}</p> : 
           oneCountryFromServer.filter(ans => ans.question === 37)[0].value  === "3" ? 
           <p>{t('result_other')}</p> : "" : 
        
           oneCountryFromServer.filter(ans => ans.question === 37).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
           <p key={res.value + "37"}>{t('result_in_situ_conservation')}</p> : 
          res.value === "1" ? 
            <p key={res.value + "37"}>{t('result_protected_areas')}</p> :
           res.value === "2" ?
          <p key={res.value + "37"}>{t('result_forests_managed')}</p> : 
           <p key={res.value + "37"}>{t('result_other')}</p> ) : "" : "" : ""}</span> 
               </td>
           </tr>  


      
        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.2.2 ${t('indicator_A_22')}`}</span>
          </p></td>
          <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? oneCountryFromServer.filter(ans => ans.question === 47).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 47)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } >
            <span className="target-indicator-text">{oneCountryFromServer !== undefined ? 

            oneCountryFromServer.filter(ans => ans.question === 47).length > 0 && 
            oneCountryFromServer.filter(ans => ans.question === 47)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 49).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 49)[0].value : "" : ""}</span>
          </p></td>

          <td className="col-3" style={{verticalAlign:"middle"}}>
             <span className="target-indicator-text ">
             {oneCountryFromServer !== undefined ? 
             oneCountryFromServer.filter(ans => ans.question === 47).length > 0 && 
             oneCountryFromServer.filter(ans => ans.question === 47)[0].value === "0" &&
             oneCountryFromServer.filter(ans => ans.question === 50).length > 0 ? 
           
             oneCountryFromServer.filter(ans => ans.question === 50).length === 1 ? 
            oneCountryFromServer.filter(ans => ans.question === 50)[0].value === "0" ? 
            <p>{t('result_ex_situ_conservation')}</p> : 
             oneCountryFromServer.filter(ans => ans.question === 50)[0].value === "1" ? 
             <p>{t('result_field_collections')}</p> :
             oneCountryFromServer.filter(ans => ans.question === 50)[0].value === "2" ?
           <p>{t('result_storage_facilities')}</p> : 
           oneCountryFromServer.filter(ans => ans.question === 50)[0].value  === "3" ? 
           <p>{t('result_other')}</p> :  "" :
           oneCountryFromServer.filter(ans => ans.question === 50).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
           <p key={res.value + "50"}>{t('result_ex_situ_conservation')}</p> : 
          res.value === "1" ? 
            <p key={res.value + "50"}>{t('result_field_collections')}</p> :
           res.value === "2" ?
          <p key={res.value + "50"}>{t('result_storage_facilities')}</p> : 
           <p key={res.value + "50"}>{t('result_other')}</p> )   : "" : ""}</span> 
               </td>
           </tr>    
        <tr >

      <td style={{backgroundColor:"#F5D6FD" }} colSpan={4}><p className="target-indicator-title">{`${t('target_table_item')} A.3 ${t('target_A_3')}`}</p></td>
            
        </tr>  
        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.3.1 ${t('indicator_A_31')}`}</span>
          </p></td>
          <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 61).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 61)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td style={{verticalAlign:"middle"}}><p>
            <span className="target-indicator-text">{oneCountryFromServer !== undefined ? 
             oneCountryFromServer.filter(ans => ans.question === 61).length > 0 && 
             oneCountryFromServer.filter(ans => ans.question === 61)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 63).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 63)[0].value : "" : ""}</span>
          </p></td>

            <td className="col-3">
    
            </td>
        </tr>  

        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.3.2 ${t('indicator_A_32')}`}</span>
          </p></td>
          <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              
              oneCountryFromServer.filter(ans => ans.question === 69).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 69)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td ><p>
          
          </p></td>

          <td className="col-3" style={{verticalAlign:"middle"}}>
             <span className="target-indicator-text ">
             {oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 69).length > 0 && 
              oneCountryFromServer.filter(ans => ans.question === 69)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 71).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 71).length === 1 ? 
            oneCountryFromServer.filter(ans => ans.question === 71)[0].value === "0" ? 
            <p>{t('result_public_entities')}</p> : 
             oneCountryFromServer.filter(ans => ans.question === 71)[0].value === "1" ? 
             <p>{t('result_private_companies')}</p> :
             oneCountryFromServer.filter(ans => ans.question === 71)[0].value === "2" ?
           <p>{t('result_private_public_partnerships')}</p> : 
           oneCountryFromServer.filter(ans => ans.question === 71)[0].value  === "3" ? 
           <p>{t('result_other')}</p> : "" :  oneCountryFromServer.filter(ans => ans.question === 71).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
           <p key={res.value + "71"}>{t('result_public_entities')}</p> : 
          res.value === "1" ? 
            <p key={res.value + "71"}>{t('result_private_companies')}</p> :
           res.value === "2" ?
          <p key={res.value + "71"}>{t('result_private_public_partnerships')}</p> : 
           <p key={res.value + "71"}>{t('result_other')}</p> ) : "" : ""}</span> 
            </td>
        </tr>  

        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.3.3 ${t('indicator_A_33')}`}</span>
          </p></td>
          <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? oneCountryFromServer.filter(ans => ans.question === 81).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 81)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } >
             <span className="target-indicator-text">{oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 81).length > 0 && 
              oneCountryFromServer.filter(ans => ans.question === 81)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 83).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 83)[0].value : "" : ""}</span> 
          </p></td>

          <td className="col-3" style={{verticalAlign:"middle"}}>
             <span className="target-indicator-text ">
             {oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 81).length > 0 && 
              oneCountryFromServer.filter(ans => ans.question === 81)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 84).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 84).length === 1 ? 
            oneCountryFromServer.filter(ans => ans.question === 84)[0].value === "0" ? 
            <p>{t('result_farmers')}</p> : 
             oneCountryFromServer.filter(ans => ans.question === 84)[0].value === "1" ? 
             <p>{t('result_local_communities')}</p> :
             oneCountryFromServer.filter(ans => ans.question === 84)[0].value === "2" ?
           <p>{t('result_forest_owners')}</p> : 
           <p>{t('result_other_stakeholders')}</p> : 
           oneCountryFromServer.filter(ans => ans.question === 84).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
           <p key={res.value + "84"}>{t('result_farmers')}</p> : 
          res.value === "1" ? 
            <p key={res.value + "84"}>{t('result_local_communities')}</p> :
           res.value === "2" ?
          <p key={res.value + "84"}>{t('result_forest_owners')}</p> : 
           <p key={res.value + "84"}>{t('result_other_stakeholders')}</p> )
           
           : "" : ""}</span> 
            </td>
        </tr>  
        <tr >
      <td style={{backgroundColor:"#DDDCFF" }} colSpan={4}><p className="target-indicator-title">{`${t('target_table_item')} A.4 ${t('target_A_4')}`}</p></td>
            
        </tr>  
        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.4.1 ${t('indicator_A_41')}`}</span>
          </p></td>
            <td>
          
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", 
            marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 95).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 95)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
          
            </td>
            <td><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } >
            <span className="target-indicator-text">{oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 95).length > 0 && 
              oneCountryFromServer.filter(ans => ans.question === 95)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 97).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 97)[0].value : "" : ""}</span>
          </p></td>
          <td className="col-3" style={{verticalAlign:"middle"}}>
             <span className="target-indicator-text ">
             {oneCountryFromServer !== undefined ? 
               oneCountryFromServer.filter(ans => ans.question === 95).length > 0 && 
               oneCountryFromServer.filter(ans => ans.question === 95)[0].value === "0" &&
            oneCountryFromServer.filter(ans => ans.question === 98).length > 0 ? 

            oneCountryFromServer.filter(ans => ans.question === 98).length === 1 ? 
            oneCountryFromServer.filter(ans => ans.question === 98)[0].value === "0" ? 
            <p>{t('result_farmers')}</p> : 
             oneCountryFromServer.filter(ans => ans.question === 98)[0].value === "1" ? 
             <p>{t('result_forest_owners')}</p> :
             oneCountryFromServer.filter(ans => ans.question === 98)[0].value === "2" ?
           <p>{t('result_private_sector')}</p> : 
           oneCountryFromServer.filter(ans => ans.question === 98)[0].value === "3" ?
           <p>{t('result_NGO')}</p> : 
           oneCountryFromServer.filter(ans => ans.question === 98)[0].value === "4" ?
           <p>{t('result_gov_org')}</p> :
           oneCountryFromServer.filter(ans => ans.question === 98)[0].value === "5" ?
           <p>{t('result_research_org')}</p> :
           oneCountryFromServer.filter(ans => ans.question === 98)[0].value === "6" ?
           <p>{t('result_relevant_ministries')}</p>
           : <p>{t('result_other_stakeholders')}</p>
           :  
           oneCountryFromServer.filter(ans => ans.question === 98).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
           <p key={res.value + "98"}>{t('result_farmers')}</p> : 
          res.value === "1" ? 
            <p key={res.value + "98"}>{t('result_forest_owners')}</p> :
           res.value === "2" ?
          <p key={res.value + "98"}>{t('result_private_sector')}</p> : 
          res.value === "3" ?
           <p key={res.value + "98"}>{t('result_NGO')}</p> :
           res.value === "4" ?
           <p key={res.value + "98"}>{t('result_gov_org')}</p> :
           res.value === "5" ?
           <p key={res.value + "98"}>{t('result_research_org')}</p> :
           res.value === "6" ?
           <p key={res.value + "98"}>{t('result_relevant_ministries')}</p> :
            <p key={res.value + "98"}>{t('result_other_stakeholders')}</p>
            )
           : "" : ""}</span> 
            </td>
        </tr>  

        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.4.2 ${t('indicator_A_42')}`}</span>
          </p></td>
            <td>
          
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", 
            marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              
              oneCountryFromServer.filter(ans => ans.question === 112).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 112)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
          
            </td>
            <td><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } >
            <span className="target-indicator-text">{oneCountryFromServer !== undefined ? 
             oneCountryFromServer.filter(ans => ans.question === 112).length > 0 && 
             oneCountryFromServer.filter(ans => ans.question === 112)[0].value === "0" && 
            oneCountryFromServer.filter(ans => ans.question === 114).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 114)[0].value : "" : ""}</span>
          </p></td>
    
          <td className="col-3" style={{verticalAlign:"middle"}}>
             <span className="target-indicator-text ">
             {oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 112).length > 0 && 
              oneCountryFromServer.filter(ans => ans.question === 112)[0].value === "0" && 
            oneCountryFromServer.filter(ans => ans.question === 115).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 115).length === 1 ? 
            oneCountryFromServer.filter(ans => ans.question === 115)[0].value === "0" ? 
            <p>{t('result_conservation_FGR')}</p> : 
             oneCountryFromServer.filter(ans => ans.question === 115)[0].value === "1" ? 
             <p>{t('result_use_FGR')}</p> :
            <p>{t('result_development_FGR')}</p>
           :  oneCountryFromServer.filter(ans => ans.question === 115).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
           <p key={res.value + "115"}>{t('result_conservation_FGR')}</p> : 
          res.value === "1" ? 
            <p key={res.value + "115"}>{t('result_use_FGR')}</p> :
            <p key={res.value + "115"}>{t('result_development_FGR')}</p>
            ) : "" : ""}</span> 
            </td>
        </tr>  

        <tr>
          <td className="col-7"><p style={{marginTop: "1rem"}}>
            <span className="country-table-header">{`${t('indicator_table_item')} A.4.3 ${t('indicator_A_43')}`}</span>
          </p></td>
            <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", 
            marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 124).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 124)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td ><p>
          </p></td>
            <td className="col-3">
            </td>
        </tr>  
      </tbody>
    </Table>
    </div> 
    <br></br>
    <div className="wrapper">
     <Table  borderless 
      style ={{ borderSpacing: "0",borderCollapse: "collapse",
      borderStyle: "hidden", marginBottom: "0px",  
      borderBottom:"0px solid trasparent !important", 
      orderBottomWidth: "0"}} >
          <thead >
    <tr >
      <th style={{backgroundColor:"#F2F2F2" }}  scope="col"><h6 style={{textAlign: props.lang !== "ar" ? "left" : "right"}} className="target-legend-element ">{t('target_table_item')} B</h6> </th>
      <th className="country-table-header" style={{backgroundColor:"#F2F2F2" }} scope="col"></th>
      <th className="country-table-header" style={{backgroundColor:"#F2F2F2" }} scope="col"></th>
      <th className="country-table-header" style={{backgroundColor:"#F2F2F2" }} scope="col"></th>
    </tr>
  </thead>
     
      <tbody> 
      <tr >
      <td style={{backgroundColor:"#CCE1F9" }} colSpan={4}><p className="target-indicator-title">{`${t('target_table_item')} B.4 ${t('target_B_4')}`}</p></td> 
            
        </tr>  
        <tr>
          <td className="col-7"><p >
            <span className="country-table-header">{`${t('indicator_table_item')} B.4.1.1 ${t('indicator_B_4_1_1')}`}</span>
          </p></td>
            <td>
          
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
           src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
            oneCountryFromServer.filter(ans => ans.question === 191).length > 0 ? 
          oneCountryFromServer.filter(ans => ans.question === 191)[0].value === "0" ?
          oneCountryFromServer.filter(ans => ans.question === 191)[0].value :
          oneCountryFromServer.filter(ans => ans.question === 191)[0].value === "1" ||
          oneCountryFromServer.filter(ans => ans.question === 191)[0].value === "2" ?
          "1" : oneCountryFromServer.filter(ans => ans.question === 191)[0].value === "3" ?
          "2" : "3" : "3" : "3"}.svg`} alt="arrow down icon" />
          
            </td>
            <td ><p>
         
          </p></td>

            <td className="col-3">
           
            </td>
        </tr>  

        <tr>
          <td className="col-7"><p >
            <span className="country-table-header">{`${t('indicator_table_item')} B.4.1.2 ${t('indicator_B_4_1_2')}`}</span>
          </p></td>
            <td>
          
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 198).length > 0 ? 
              oneCountryFromServer.filter(ans => ans.question === 198)[0].value === "0" ?
              oneCountryFromServer.filter(ans => ans.question === 198)[0].value :
              oneCountryFromServer.filter(ans => ans.question === 198)[0].value === "1" ||
              oneCountryFromServer.filter(ans => ans.question === 198)[0].value === "2" ?
              "1" : oneCountryFromServer.filter(ans => ans.question === 198)[0].value === "3" ?
              "2" : "3" : "3" : "3"}.svg`} alt="arrow down icon" />
          
            </td>
            <td ><p>
         
          </p></td>

            <td className="col-3">
           
            </td>
        </tr> 
        <tr>
          <td className="col-7"><p >
            <span className="country-table-header">{`${t('indicator_table_item')} B.4.1.3 ${t('indicator_B_4_1_3')}`}</span>
          </p></td>
            <td>
          
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 205).length > 0 ? 
              oneCountryFromServer.filter(ans => ans.question === 205)[0].value === "0" ||
              oneCountryFromServer.filter(ans => ans.question === 205)[0].value === "1"  ?
              oneCountryFromServer.filter(ans => ans.question === 205)[0].value :
              oneCountryFromServer.filter(ans => ans.question === 205)[0].value === "2" ||
              oneCountryFromServer.filter(ans => ans.question === 205)[0].value === "3" ?
              "2" :
            "3" :  "3" : "3"}.svg`} alt="arrow down icon" />
          
            </td>
            <td ><p>
         
          </p></td>

            <td className="col-3">
           
            </td>
        </tr> 
       
      
        <tr>
          <td className="col-7"><p >
            <span className="country-table-header">{`${t('indicator_table_item')} B.4.2 ${t('indicator_B_42')}`}</span>
          </p></td>
            <td>
          
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 213).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 213)[0].value : "3" : "3"}.svg`} alt="arrow down icon" />
          
            </td>
            <td ><p>
         
          </p></td>

            <td className="col-3"><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } >
            <span className="target-indicator-text">{oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 213).length > 0 && 
              oneCountryFromServer.filter(ans => ans.question === 213)[0].value === "0" && 
            oneCountryFromServer.filter(ans => ans.question === 215).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 215)[0].value : "" : ""}</span></p>
            </td>
        </tr> 
      
        <tr>
          <td className="col-7"><p >
            <span className="country-table-header">{`${t('indicator_table_item')} B.4.3 ${t('indicator_B_43')}`}</span>
          </p></td>
            <td>
            <img style={{marginTop: "1rem", marginRight: props.lang === "ar" ? "0rem" : "0.2rem", marginLeft: props.lang === "ar" ? "0.2rem" : "0rem"} } 
            src={process.env.PUBLIC_URL + `/img/circle_${oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 221).length > 0 ? 
              oneCountryFromServer.filter(ans => ans.question === 221)[0].value === "0" ?
              oneCountryFromServer.filter(ans => ans.question === 221)[0].value :
              oneCountryFromServer.filter(ans => ans.question === 221)[0].value === "1"  ||
              oneCountryFromServer.filter(ans => ans.question === 221)[0].value === "2" ?
              "1" :
              oneCountryFromServer.filter(ans => ans.question === 221)[0].value === "3" ?
              "2" :
            "3" :  "3" : "3"}.svg`} alt="arrow down icon" />
            </td>
            <td ><p>
         
          </p></td>

            <td className="col-3"><p style={{marginTop: "0.7rem", marginBottom: "0rem"} } ></p>
            {/* <span className="target-indicator-text">{oneCountryFromServer !== undefined ? 
              oneCountryFromServer.filter(ans => ans.question === 213).length > 0 && 
              oneCountryFromServer.filter(ans => ans.question === 213)[0].value === "0" && 
            oneCountryFromServer.filter(ans => ans.question === 223).length > 0 ? 
            oneCountryFromServer.filter(ans => ans.question === 223)[0].value : "" : ""}</span></p> */}
            </td>
        </tr>  

      </tbody>
    </Table>
    </div>
</div>
    
    
    </div>: null}</div> 
      </React.Fragment>
    );
  }

  export default PoliciesResponsesTable;